import {
  Box,
  BoxProps,
  Collapse,
  HStack,
  Icon,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";

interface SideNavGroupProps extends BoxProps {
  title: string;
  icon?: React.ReactElement;
}

export const SideNavGroup = ({ title, icon, children }: SideNavGroupProps) => {
  const [show, setShow] = useState(true);

  return (
    <>
      <Box
        color={"muted"}
        borderRadius={"md"}
        py={1}
        px={1}
        mb={1}
        cursor={"pointer"}
        _hover={{
          bg: "tertiary.light",
          color: "white",
        }}
        onClick={() => {
          setShow(!show);
        }}
      >
        <HStack>
          {icon && icon}
          <Text fontSize={"14px"}>{title}</Text>
          <Spacer />
          {show ? (
            <Icon as={RiArrowDropUpLine} h={6} w={6} />
          ) : (
            <Icon as={RiArrowDropDownLine} h={6} w={6} />
          )}
        </HStack>
      </Box>
      <Collapse in={show}>{children}</Collapse>
    </>
  );
};
